module.exports = __webpack_public_path__ + "static/home_czerniak-eaad69a8499d3e5c184ada1d1b001957.svg";